import { createPhoneSuggestionsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const PhoneSuggestionsService = createPhoneSuggestionsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
